export default __webpack_public_path__ + "static/media/btn-arrow-prev.f3155905.svg";